module.exports = __webpack_public_path__ + "img/shengxin@2x.f340142b.png";